import { render, staticRenderFns } from "./MessagesAccordionItemBS46.vue?vue&type=template&id=74a4501e"
import script from "./MessagesAccordionItemBS46.vue?vue&type=script&lang=js"
export * from "./MessagesAccordionItemBS46.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports